// extracted by mini-css-extract-plugin
export default {"header":"header_header__MhatS","content":"header_content__Oq5rs","child":"header_child__MR4dC"};